import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { Collapse, Tabs } from 'antd';
import OtherRoleView from 'components/Admin/OtherRole/OtherRoleView';
import RolesView from "../../components/Admin/Roles/RolesView";
import TaskLinksView from "../../components/Admin/TaskLinks/TaskLinksView";
import ChecklistRevisions from "../../components/Admin/ChecklistRevisions";
import TypesView from "../../components/Admin/TaskTypes/TypesView";
import PCContractorView from "../../components/Admin/PCContractor/PCContractorView";

const inner = {
    paddingRight: "20px"
}

const TabPane = Tabs.TabPane;
function Admin(props)
{
    return(
        <div className="container-fluid">
            <Tabs>
                <TabPane tab="Roles" key='admin_roles'>
                    <RolesView />
                </TabPane>
                <TabPane tab="Other Roles" key='admin_OtherRoles'>
                    <OtherRoleView />
                </TabPane>
                <TabPane tab="P&C Contractors" key='admin_PCContractors'>
                    <PCContractorView />
                </TabPane>
                <TabPane tab="Task Types" key='admin_TaskTypes'>
                    <TypesView />
                </TabPane>
                <TabPane tab="Task Links" key='admin_TaskLinks'>
                    <TaskLinksView />
                </TabPane>
                <TabPane tab="Task Revisions" key='admin_task_revisions'>
                    <ChecklistRevisions />
                </TabPane>
            </Tabs>
        </div>
    )
}
export default Admin;